module.exports = __webpack_public_path__ + "img/propertyoffice4.984de0c6.png";